module.exports = __webpack_public_path__ + "img/s1-loading2.584b607f.gif";